<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('clients.clients')"
    class="client-filter"
    optional
  >
    <ClientMultiSelect :id="inputId" v-model="selectedDomains" />
  </InputWrapper>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, onMounted, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { DomainReference } from '@rygen/rygen-ui/model';
import { notNull } from '@rygen/rygen-ui/util';

import { useClientStore } from '@/stores/Client';

import ClientMultiSelect from '@/components/client/ClientMultiSelect.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const modelValue = defineModel({
  type: Array as PropType<string[]>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { flatClients, loadClients } = useClientStore();
const { t } = useI18n();

const selectedDomains = computed({
  get() {
    return modelValue.value
      .map((naturalId) =>
        flatClients.value.find((c) => c.naturalId === naturalId),
      )
      .filter(notNull);
  },
  set(newVal: DomainReference[]) {
    modelValue.value = newVal.map((d) => d.naturalId).filter(notNull);
  },
});

onMounted(() => {
  loadClients();
});
</script>

<style>
.client-filter {
  width: initial;
  min-width: var(--search-builder-filter-width);
  max-width: 300px;
}
</style>
